import { computed, ref } from 'vue'
import { getHeaderData, type ICompanyResponse } from '@/infrastructure/api-functions'
import { useGlobalState } from './use-global-store';
import { getCompanyLocation, getCompanyOwnershipType } from '@/infrastructure/utils/company-info';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const companyInfo = ref<ICompanyResponse>();
export const useCompanyBasic = () => {
    const route = useRoute();
    const { companyId, updateLimitInfo } = useGlobalState();
    const { t } = useI18n();
    const isLoading = ref<boolean>(false);
    const isShowSubCompanyBtn = ref<boolean>(true);
    const routerNameBlackList = ['paper', 'relation-ship']

    async function getCompanyInfo() {
        isLoading.value = true;
        companyInfo.value = await getHeaderData(companyId.value).finally(() => {
            isLoading.value = false;
        });
        updateLimitInfo(!companyInfo.value?.has_access);
    }

    const companyTitle = computed(() => {
        if (!companyInfo.value) {
            return [];
        }
        const companyType = getCompanyOwnershipType(companyInfo.value);
        isShowSubCompanyBtn.value = companyInfo.value?.subsidiaries !== 0 && !routerNameBlackList.includes(route.name as string);
        const { founded_date } = companyInfo.value;
        return [
            companyType ? t(`companyType.${companyType}`) : '',
            getCompanyLocation(companyInfo.value),
            founded_date?.toString()?.slice(0, 4)
        ].filter(Boolean) as string[];
    });

    return {
        companyTitle,
        isLoading,
        isShowSubCompanyBtn,
        companyInfo,
        getCompanyInfo,
    };
};
